// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdrCalendarWrapper {
  box-sizing: border-box;
  background: #ffffff;
  -webkit-user-select: none;
          user-select: none;
}

.rdrDateDisplay {
  display: flex;
  justify-content: space-between;
}

.rdrDateDisplayItem {
  flex: 1 1;
  width: 0;
  text-align: center;
  color: inherit;
}
.rdrDateDisplayItem + .rdrDateDisplayItem {
  margin-left: 0.833em;
}
.rdrDateDisplayItem input {
  text-align: inherit;
}
.rdrDateDisplayItem input:disabled {
  cursor: default;
}

.rdrMonthAndYearWrapper {
  box-sizing: inherit;
  display: flex;
  justify-content: space-between;
}

.rdrMonthAndYearItem {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  position: relative;
}

.rdrMonthAndYearIconLeft {
  left: 0;
}

.rdrMonthAndYearIconRight {
  right: 0;
}

.rdrMonthAndYearPickers {
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rdrNextPrevButton {
  box-sizing: inherit;
  cursor: pointer;
  outline: none;
}

.rdrMonths {
  display: flex;
}

.rdrMonthsVertical {
  flex-direction: column;
}

.rdrMonthsHorizontal > div > div > div {
  display: flex;
  flex-direction: row;
}

.rdrMonth {
  flex: 1 1;
}

.rdrWeekDays {
  display: flex;
  margin-bottom: 4px;
}

.rdrWeekDay {
  flex-basis: 14.2857142857%;
  box-sizing: inherit;
  text-align: center;
}

.rdrDays {
  display: flex;
  flex-wrap: wrap;
}

.rdrInfiniteMonths {
  overflow: auto;
}

.rdrDateRangeWrapper {
  -webkit-user-select: none;
          user-select: none;
}

.rdrDateInput {
  position: relative;
}
.rdrDateInput input {
  outline: none;
}
.rdrDateInput .rdrWarning {
  position: absolute;
  font-size: 1.6em;
  line-height: 1.6em;
  top: 0;
  right: 0.25em;
  color: #FF0000;
}

.rdrDay {
  box-sizing: inherit;
  width: 14.2857142857%;
  position: relative;
  font: inherit;
  cursor: pointer;
}

.rdrDayNumber {
  display: block;
  position: relative;
}
.rdrDayNumber span {
  color: #1d2429;
}

.rdrDayDisabled {
  cursor: not-allowed;
}

@supports (-ms-ime-align: auto) {
  .rdrDay {
    flex-basis: 14.285% !important;
  }
}
.rdrSelected,
.rdrInRange,
.rdrStartEdge,
.rdrEndEdge {
  pointer-events: none;
}

.rdrDayStartPreview,
.rdrDayInPreview,
.rdrDayEndPreview {
  pointer-events: none;
}

.rdrDateRangePickerWrapper {
  -webkit-user-select: none;
          user-select: none;
}

.selectedToggleButton {
  background-color: red;
}

.rdrStaticRange {
  font-size: inherit;
}

.rdrInputRange {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/components/DateRangePicker/Calendar/index.scss","webpack://./src/components/DateRangePicker/styles.scss","webpack://./src/components/DateRangePicker/DateRange/index.scss","webpack://./src/components/DateRangePicker/DateInput/index.scss","webpack://./src/components/DateRangePicker/DayCell/index.scss","webpack://./src/components/DateRangePicker/DateRangePicker/index.scss","webpack://./src/components/DateRangePicker/DefinedRange/index.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,8BAAA;ACCJ;;ADEA;EACI,SAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;ACCJ;ADCI;EACI,oBAAA;ACCR;ADEI;EACI,mBAAA;ACAR;ADEQ;EACI,eAAA;ACAZ;;ADOA;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;ACJJ;;ADOA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;ACJJ;;ADOA;EACI,OAAA;ACJJ;;ADOA;EACI,QAAA;ACJJ;;ADOA;EACI,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACJJ;;ADWA;EACI,mBAAA;EACA,eAAA;EACA,aAAA;ACRJ;;ADeA;EACI,aAAA;ACZJ;;ADeA;EACI,sBAAA;ACZJ;;ADeA;EACI,aAAA;EACA,mBAAA;ACZJ;;ADeA;EACI,SAAA;ACZJ;;ADeA;EACI,aAAA;EACA,kBAAA;ACZJ;;ADeA;EACI,0BAAA;EACA,mBAAA;EACA,kBAAA;ACZJ;;ADeA;EACI,aAAA;EACA,eAAA;ACZJ;;ADmBA;EACI,cAAA;AChBJ;;ACjGA;EACI,yBAAA;UAAA,iBAAA;ADoGJ;;AErGA;EACI,kBAAA;AFwGJ;AEtGI;EACI,aAAA;AFwGR;AErGI;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,aAAA;EACA,cAAA;AFuGR;;AGpHA;EACI,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AHuHJ;;AGpHA;EACI,cAAA;EACA,kBAAA;AHuHJ;AGrHI;EACI,cAAA;AHuHR;;AGnHA;EACI,mBAAA;AHsHJ;;AGnHA;EACI;IACI,8BAAA;EHsHN;AACF;AGnHA;;;;EAII,oBAAA;AHqHJ;;AGhHA;;;EAGI,oBAAA;AHmHJ;;AI1JA;EACI,yBAAA;UAAA,iBAAA;AJ6JJ;;AI1JA;EACI,qBAAA;AJ6JJ;;AK5JA;EACI,kBAAA;AL+JJ;;AK1JA;EACI,aAAA;AL6JJ","sourcesContent":[".rdrCalendarWrapper {\n    box-sizing: border-box;\n    background: #ffffff;\n    user-select: none;\n}\n\n.rdrDateDisplay {\n    display: flex;\n    justify-content: space-between;\n}\n\n.rdrDateDisplayItem {\n    flex: 1 1;\n    width: 0;\n    text-align: center;\n    color: inherit;\n\n    &+& {\n        margin-left: 0.833em;\n    }\n\n    input {\n        text-align: inherit;\n\n        &:disabled {\n            cursor: default;\n        }\n    }\n}\n\n.rdrDateDisplayItemActive {}\n\n.rdrMonthAndYearWrapper {\n    box-sizing: inherit;\n    display: flex;\n    justify-content: space-between;\n}\n\n.rdrMonthAndYearItem {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: center;\n    position: relative;\n}\n\n.rdrMonthAndYearIconLeft {\n    left: 0;\n}\n\n.rdrMonthAndYearIconRight {\n    right: 0;\n}\n\n.rdrMonthAndYearPickers {\n    flex: 1 1 auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.rdrMonthPicker {}\n\n.rdrYearPicker {}\n\n.rdrNextPrevButton {\n    box-sizing: inherit;\n    cursor: pointer;\n    outline: none;\n}\n\n.rdrPrevButton {}\n\n.rdrNextButton {}\n\n.rdrMonths {\n    display: flex;\n}\n\n.rdrMonthsVertical {\n    flex-direction: column;\n}\n\n.rdrMonthsHorizontal>div>div>div {\n    display: flex;\n    flex-direction: row;\n}\n\n.rdrMonth {\n    flex: 1;\n}\n\n.rdrWeekDays {\n    display: flex;\n    margin-bottom: 4px;\n}\n\n.rdrWeekDay {\n    flex-basis: calc(100% / 7);\n    box-sizing: inherit;\n    text-align: center;\n}\n\n.rdrDays {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.rdrDateDisplayWrapper {}\n\n.rdrMonthName {}\n\n.rdrInfiniteMonths {\n    overflow: auto;\n}",".rdrCalendarWrapper {\n  box-sizing: border-box;\n  background: #ffffff;\n  user-select: none;\n}\n\n.rdrDateDisplay {\n  display: flex;\n  justify-content: space-between;\n}\n\n.rdrDateDisplayItem {\n  flex: 1 1;\n  width: 0;\n  text-align: center;\n  color: inherit;\n}\n.rdrDateDisplayItem + .rdrDateDisplayItem {\n  margin-left: 0.833em;\n}\n.rdrDateDisplayItem input {\n  text-align: inherit;\n}\n.rdrDateDisplayItem input:disabled {\n  cursor: default;\n}\n\n.rdrMonthAndYearWrapper {\n  box-sizing: inherit;\n  display: flex;\n  justify-content: space-between;\n}\n\n.rdrMonthAndYearItem {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: center;\n  position: relative;\n}\n\n.rdrMonthAndYearIconLeft {\n  left: 0;\n}\n\n.rdrMonthAndYearIconRight {\n  right: 0;\n}\n\n.rdrMonthAndYearPickers {\n  flex: 1 1 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.rdrNextPrevButton {\n  box-sizing: inherit;\n  cursor: pointer;\n  outline: none;\n}\n\n.rdrMonths {\n  display: flex;\n}\n\n.rdrMonthsVertical {\n  flex-direction: column;\n}\n\n.rdrMonthsHorizontal > div > div > div {\n  display: flex;\n  flex-direction: row;\n}\n\n.rdrMonth {\n  flex: 1;\n}\n\n.rdrWeekDays {\n  display: flex;\n  margin-bottom: 4px;\n}\n\n.rdrWeekDay {\n  flex-basis: 14.2857142857%;\n  box-sizing: inherit;\n  text-align: center;\n}\n\n.rdrDays {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.rdrInfiniteMonths {\n  overflow: auto;\n}\n\n.rdrDateRangeWrapper {\n  user-select: none;\n}\n\n.rdrDateInput {\n  position: relative;\n}\n.rdrDateInput input {\n  outline: none;\n}\n.rdrDateInput .rdrWarning {\n  position: absolute;\n  font-size: 1.6em;\n  line-height: 1.6em;\n  top: 0;\n  right: 0.25em;\n  color: #FF0000;\n}\n\n.rdrDay {\n  box-sizing: inherit;\n  width: 14.2857142857%;\n  position: relative;\n  font: inherit;\n  cursor: pointer;\n}\n\n.rdrDayNumber {\n  display: block;\n  position: relative;\n}\n.rdrDayNumber span {\n  color: #1d2429;\n}\n\n.rdrDayDisabled {\n  cursor: not-allowed;\n}\n\n@supports (-ms-ime-align: auto) {\n  .rdrDay {\n    flex-basis: 14.285% !important;\n  }\n}\n.rdrSelected,\n.rdrInRange,\n.rdrStartEdge,\n.rdrEndEdge {\n  pointer-events: none;\n}\n\n.rdrDayStartPreview,\n.rdrDayInPreview,\n.rdrDayEndPreview {\n  pointer-events: none;\n}\n\n.rdrDateRangePickerWrapper {\n  user-select: none;\n}\n\n.selectedToggleButton {\n  background-color: red;\n}\n\n.rdrStaticRange {\n  font-size: inherit;\n}\n\n.rdrInputRange {\n  display: flex;\n}",".rdrDateRangeWrapper {\n    user-select: none;\n}",".rdrDateInput {\n    position: relative;\n\n    input {\n        outline: none;\n    }\n\n    .rdrWarning {\n        position: absolute;\n        font-size: 1.6em;\n        line-height: 1.6em;\n        top: 0;\n        right: .25em;\n        color: #FF0000;\n    }\n}",".rdrDay {\n    box-sizing: inherit;\n    width: calc(100% / 7);\n    position: relative;\n    font: inherit;\n    cursor: pointer;\n}\n\n.rdrDayNumber {\n    display: block;\n    position: relative;\n\n    span {\n        color: #1d2429;\n    }\n}\n\n.rdrDayDisabled {\n    cursor: not-allowed;\n}\n\n@supports (-ms-ime-align: auto) {\n    .rdrDay {\n        flex-basis: 14.285% !important;\n    }\n}\n\n.rdrSelected,\n.rdrInRange,\n.rdrStartEdge,\n.rdrEndEdge {\n    pointer-events: none;\n}\n\n.rdrInRange {}\n\n.rdrDayStartPreview,\n.rdrDayInPreview,\n.rdrDayEndPreview {\n    pointer-events: none;\n}\n\n.rdrDayHovered {}\n\n.rdrDayActive {}",".rdrDateRangePickerWrapper {\n    user-select: none;\n}\n\n.selectedToggleButton {\n    background-color: red;\n}",".rdrDefinedRangesWrapper {}\n\n.rdrStaticRanges {\n    \n}\n\n.rdrStaticRange {\n    font-size: inherit;\n}\n\n.rdrStaticRangeLabel {}\n\n.rdrInputRange {\n    display: flex;\n}\n\n.rdrInputRangeInput {}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
